import { DIMENSIONS } from '@hqo/react-components-library/dist/utils';
import styled from 'styled-components';
import { EXTRA_LARGE_DIMENSION, PLUS_LARGE_DIMENSION } from 'shared/consts';

const TOP_DESKTOP_CONTENT_HEIGHT = 290;
const TOP_DESKTOP_CONTENT_HEIGHT_WITH_BOOKINGS = 530;
const TOP_MOBILE_CONTENT_HEIGHT = 208;
const TOP_MOBILE_CONTENT_HEIGHT_WITH_BOOKINGS = 390;
const DEFAULT_MOBILE_TOP = 65;

export const Container = styled.div<{ isLoading?: boolean }>`
  padding: 34px 52px 0 52px;
  height: 100%;
  display: flex;
  flex-direction: column;
  ${({ isLoading }) => isLoading && 'padding: 0;'};

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    padding: 32px 16px 0 16px;
    ${({ isLoading }) => isLoading && 'padding: 0;'}
  }

  @media only screen and (max-width: ${DIMENSIONS.SMALL}) {
    padding: 28px 0 0 0;
  }
`;

export const HeaderContentContainer = styled.div`
  width: 100%;

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    padding: 0 13px;
  }
`;

export const Grid = styled.div<{
  isNoResources: boolean;
  isCompactUiEnabled: boolean;
  isSwipeModalContent?: boolean;
  isUpcomingBookingsSectionVisible?: boolean;
  /** The redesigned list: row cards, wrapped as many per line as fit, spaced tightly. */
  isRowList?: boolean;
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* The row cards decide how many fit per line — see StyledResourceRow; this only has to let them
     wrap and start them at the top rather than stretching them down the column. */
  ${({ isRowList }) => isRowList && 'align-content: flex-start;'}
  ${({ isSwipeModalContent }) => !isSwipeModalContent && 'overflow: auto;'}
  height: calc(100vh - ${TOP_DESKTOP_CONTENT_HEIGHT}px);
  ${({ isUpcomingBookingsSectionVisible }) =>
    isUpcomingBookingsSectionVisible && `height: calc(100vh - ${TOP_DESKTOP_CONTENT_HEIGHT_WITH_BOOKINGS}px);`}
  /* The gallery of photo tiles needs air between them; a list of rows reads as one list only if the
     rows sit close, which is the 10px the design uses. */
  gap: ${({ isRowList }) => (isRowList ? '10px' : '24px')};

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    padding: 0 13px;
    flex-direction: column;
    height: calc(100vh - ${TOP_MOBILE_CONTENT_HEIGHT}px);
    ${({ isUpcomingBookingsSectionVisible }) =>
      isUpcomingBookingsSectionVisible && `height: calc(100vh - ${TOP_MOBILE_CONTENT_HEIGHT_WITH_BOOKINGS}px);`}
    ${({ isNoResources }) => isNoResources && `height: calc(100% - ${DEFAULT_MOBILE_TOP}px);`}
    flex-wrap: nowrap;
  }
`;

export const StyledBackLink = styled.div`
  margin-bottom: 18px;
`;

export const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
`;

export const ResourcesListContainer = styled.div<{ isMapViewEnabled?: boolean; isLoadingState?: boolean }>`
  width: ${({ isMapViewEnabled, isLoadingState }) => (isMapViewEnabled && !isLoadingState ? '65%' : '100%')};
  height: 100%;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: ${EXTRA_LARGE_DIMENSION}) {
    width: ${({ isMapViewEnabled, isLoadingState }) => (isMapViewEnabled && !isLoadingState ? '50%' : '100%')};
  }

  @media only screen and (max-width: ${PLUS_LARGE_DIMENSION}) {
    width: ${({ isMapViewEnabled, isLoadingState }) => (isMapViewEnabled && !isLoadingState ? '35%' : '100%')};
  }

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    width: 100%;
  }
`;

export const MobileTitleContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-bottom: 12px;
`;

export const MobileTitleBookings = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: end;
`;

export const MobileBookingsText = styled.div`
  font: 500 16px/22px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.palette.systemBlack};
`;
